/* eslint-disable */

/* webpack注入的变量 */

// 项目运行环境
export const TL_NODE_ENV = NODE_ENV;

// 时间线API域名
export const TL_API_URL = timelineApiUrl;

// 评论API域名
export const COMMENT_BASE_PATH = commentBasePath;

// 点赞API域名
export const STAR_BASE_PATH = starBasePath;

/* eslint-enable */

// 时间线广播频道
export const BC_CLOSE_SAME_PAGE = 'timeline_bc_close_same_page';

// 时间线评论id
export const COMMENT_APP_ID = '10';

/* 时间线列表类型 */
// 嵌入热点专题的时间线列表
export const EVENT_LIST_INFLOW = 'eventList/inflow';

// 时间线底页的时间线列表
export const EVENT_LIST_PAGE = 'eventList/page';

// 卡片分享的时间线列表
export const EVENT_LIST_SHARE = 'eventList/share';

// 我的追踪页的时间线列表
export const EVENT_LIST_MYFOLLOW = 'eventList/myFollow';

// 时间线二维码在localStorage中存储的前缀
export const QRCODE_PREFIX = 'timeline/qrcode/';

// 时间线二维码在localStorage中存储的版本（需要清空本地换成或者存储结构发生变化时修改）
export const QRCODE_VERSION = '0.0.2';
